import React,{useEffect, useState} from 'react';

import ReserveSty from './contentReserve.module.css'

const ContentReserve=()=>{
    return(
        <div className={ReserveSty.reserveDiv}>
            <div className={ReserveSty.titleSty}>马上预约您的专属顾问，深入了解经纬通达的相关服务</div>
            <div className={ReserveSty.iconSty}></div>
            <div className={ReserveSty.reserveBtnSty}><a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=3465207972&site=qq&menu=yes">立即预约</a></div>
        </div>
    );
}

export default ContentReserve;
